import formatCurrency from "./formatCurrency";

type VoucherRuleType = {
  enabled: boolean;
  amount: number;
  intlUnit: "currency" | "percent";
  minOrderValueFloat: number;
};

declare global {
  interface Window {
    connox: {
      newsletterVoucher: {
        enabled: string;
        endDate: string;
        value: string;
        minimumOrderValue: string;
        voucherType: "Relative" | "Fix";
        minItemQuantity: string;
        validIfInStock: string;
      };
    };
  }
}

class RegistrationVoucher {
  private readonly voucherRule: VoucherRuleType | null;
  private readonly percentFormatter: Intl.NumberFormat;
  public readonly amountFormatted: string | null;
  public readonly minOrderValueFormatted: string | null;

  constructor() {
    // read values from global window object
    const nv = window.connox?.newsletterVoucher;

    // value can be empty even if enabled is 1, this is normal, so we have to check both
    this.voucherRule =
      nv && nv.value !== "" && nv.enabled === "1"
        ? {
          enabled: true,
          amount: parseFloat(nv.value),
          intlUnit: nv.voucherType === "Relative" ? "percent" : "currency",
          minOrderValueFloat: parseFloat(nv.minimumOrderValue),
        }
        : null;

    this.percentFormatter = new Intl.NumberFormat([], {
      style: "percent",
    });

    this.amountFormatted = this.formatAmountByUnit();

    if (this.rule) {
      this.minOrderValueFormatted = formatCurrency({
        value: this.rule.minOrderValueFloat,
        fractionDigits: 0,
      });
    } else {
      this.minOrderValueFormatted = null;
    }
  }

  public get rule(): VoucherRuleType | null {
    return this.voucherRule;
  }

  public get enabled(): boolean {
    return !!this.rule;
  }

  public get minOrderValue(): number {
    return this.rule?.minOrderValueFloat ?? 0.0;
  }

  private formatAmountByUnit(): string | null {
    if (!this.rule) {
      return null;
    }

    if (this.rule.intlUnit === "percent") {
      return this.percentFormatter.format(this.rule.amount);
    }

    return formatCurrency({
      value: this.rule.amount,
      fractionDigits: 0,
    });
  }
}

const registrationVoucher = new RegistrationVoucher();
export {registrationVoucher as RegistrationVoucher};
